import axios from 'axios';
import { Dispatch } from 'redux';
import { UserInfoInterface } from 'types';
import { generateConfig, refreshTokenHandler } from 'utilityFunctions';
import { MONEY_SAVED, MoneySavedInterface } from "../actionTypes/types";

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const RefreshMoneySavedData = (
  accessToken: string,
  refreshToken: string,
  userInfo: UserInfoInterface,
  navigate: any
) => 
  async (dispatch: Dispatch<MoneySavedInterface>) => {
    if (!accessToken) {
      return;
    }

    const config = generateConfig(accessToken);
    try {
      const moneySavedResponse = await axios.get(
        `${BASE_URL}/api/meals/moneySaved`,
        config
      );

      if (moneySavedResponse.status === 200) {
        dispatch({
          type: MONEY_SAVED,
          payload: moneySavedResponse.data.moneySaved,
        });
        return moneySavedResponse.data.moneySaved;
      }
    } catch (error: any) {
      if (error.response && error.response.status === 401) {
        try {
          const refreshedTokens = await refreshTokenHandler(
            refreshToken,
            userInfo,
            dispatch,
            navigate
          );
          const refreshedConfig = generateConfig(refreshedTokens?.accessToken);
          const refreshedMoneySavedResponse = await axios.get(
            `${BASE_URL}/api/meals/moneySaved`,
            refreshedConfig
          );

          if (refreshedMoneySavedResponse.status === 200) {
            dispatch({
              type: MONEY_SAVED,
              payload: refreshedMoneySavedResponse.data.moneySaved,
            });
            return refreshedMoneySavedResponse.data.moneySaved;
          }
        } catch (refreshError: any) {
          console.error('Error refreshing token:', refreshError);
        }
      } else {
        console.error('Error getting money saved info:', error);
      }
    }
    return null;
  };
